import { render, staticRenderFns } from "./RootModal.vue?vue&type=template&id=ea6a8f4a&"
import script from "./RootModal.vue?vue&type=script&lang=ts&"
export * from "./RootModal.vue?vue&type=script&lang=ts&"
import style0 from "./RootModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports